/**
 * Ensures Seal Subscriptions defaults to one-time purchase on PDP load so
 * Add to cart is immediately usable without selecting a purchase option first.
 */
(() => {
  if (window.__pdpSealOneTimeDefaultInit) return;

  window.__pdpSealOneTimeDefaultInit = true;

  const ONE_TIME_MARKERS = [
    'eenmalig',
    'one-time',
    'one time',
    'einmalig',
    'achat unique',
    'compra única',
    'compra unica',
  ];

  /**
   * @param {Element} optionNode
   * @returns {boolean}
   */
  const isOneTimePurchaseOption = (optionNode) => {
    const optionText = optionNode.textContent?.toLowerCase() || '';

    if (ONE_TIME_MARKERS.some((marker) => optionText.includes(marker))) {
      return true;
    }

    const radio = optionNode.querySelector('input[type="radio"]');

    if (!radio) {
      return false;
    }

    const value = (radio.value || '').trim();

    if (value === '' || value === '0') {
      return true;
    }

    return !/^\d+$/.test(value);
  };

  /**
   * @param {ParentNode} root
   */
  const enableAddToCartButtons = (root) => {
    for (const button of root.querySelectorAll(
      'button[name="add"].add-to-cart-button, button[name="add"][ref="addToCartButton"]'
    )) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }
  };

  /**
   * @param {ParentNode} scope
   */
  const selectOneTimePurchaseDefault = (scope = document) => {
    const widgets = scope.querySelectorAll('.product-information .sealsubs-container');

    for (const widget of widgets) {
      if (widget.dataset.pdpOneTimeDefaultApplied === 'true') continue;

      const optionsContainer = widget.querySelector('.sls-purchase-options-container');
      if (!optionsContainer) continue;

      const optionNodes = [...optionsContainer.querySelectorAll('.sls-option-container')];
      if (optionNodes.length === 0) continue;

      const oneTimeOption = optionNodes.find(isOneTimePurchaseOption);
      if (!oneTimeOption) continue;

      const oneTimeInput = oneTimeOption.querySelector('input[type="radio"]');
      if (!oneTimeInput) continue;

      if (!oneTimeInput.checked) {
        oneTimeInput.checked = true;
        oneTimeInput.dispatchEvent(new Event('input', { bubbles: true }));
        oneTimeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      widget.dataset.pdpOneTimeDefaultApplied = 'true';

      const productDetails = widget.closest('[data-testid="product-information-details"]');
      if (productDetails) {
        enableAddToCartButtons(productDetails);
      }
    }
  };

  let initScheduled = false;

  /**
   * @param {ParentNode} scope
   */
  const scheduleSelectOneTimePurchaseDefault = (scope = document) => {
    if (initScheduled) return;

    initScheduled = true;
    requestAnimationFrame(() => {
      initScheduled = false;
      selectOneTimePurchaseDefault(scope);
    });
  };

  const productDetailsRoot =
    document.querySelector('[data-testid="product-information-details"]') ||
    document.querySelector('.product-information .product-details[id^="ProductInformation-"]');

  if (productDetailsRoot) {
    const observer = new MutationObserver(() => {
      scheduleSelectOneTimePurchaseDefault(productDetailsRoot);
    });

    observer.observe(productDetailsRoot, { childList: true, subtree: true });
    scheduleSelectOneTimePurchaseDefault(productDetailsRoot);
  }

  window.addEventListener('load', () => {
    scheduleSelectOneTimePurchaseDefault();
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    scheduleSelectOneTimePurchaseDefault(event.target);
  });
})();
